import createAccessibleSlickGrid from './accessibleSlickGrid';

jQuery(function () {
	window.LA.AccessibleSlickGrid = createAccessibleSlickGrid(window.jQuery);
});
